import { Modal, useModals } from 'almanac-ui/Modal'
import { NewValueDialogProps } from 'blaze-ui/ArrayInput/Types'
import { useState } from 'react'
import { Input } from 'almanac-ui/TextInputField/Input'

export const NewValueModal = ({ title, placeholder, onSubmit }: NewValueDialogProps) => {
  const { closeModal } = useModals()
  const [newValue, setNewValue] = useState('')

  return (
    <Modal.Root>
      <Modal.Header title={title} />
      <Modal.Content>
        <Input
          autoFocus
          size="lg"
          name="value"
          variant="grey"
          placeholder={placeholder}
          onChange={(e) => setNewValue(e.target.value)}
          value={newValue}
        />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={closeModal} size="lg" variant="tertiary">
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={() => onSubmit(newValue)} size="lg" variant="primary">
            Submit
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
